import React from "react"
import withStyles from "@material-ui/core/styles/withStyles"
import clsx from "clsx"
import HomePageWrapper from "../Common/PageWrappers/HomePageWrapper"
import { useLazyLoadSelector } from "../../util/redux"
import AlertsTable from "../Alerts/alertsTable"
import { fetchUserAlerts, fetchUserAlertSettings } from "../../actions/alertActions"
import { fetchGroups } from "../../actions/groupActions"

const styles = (theme) => ({
  devicesCard: {
    width: "20vw",
  },
  toolbar: theme.mixins.toolbar,
  root: {},
  details: {
    display: "flex",
  },
  cardColor: {
    background: "linear-gradient(60deg, #0093C5, #1195C9)",
    color: "white",
  },
  avatar: {
    height: 110,
    width: 100,
    flexShrink: 0,
    flexGrow: 0,
  },
  locationText: {
    paddingLeft: "15px",
  },
  buttonProperty: {
    position: "absolute",
    top: "50%",
  },
  uiProgess: {
    position: "fixed",
    zIndex: "1000",
    height: "31px",
    width: "31px",
    left: "50%",
    top: "35%",
  },
  progess: {
    position: "absolute",
  },
  uploadButton: {
    marginLeft: "8px",
    margin: theme.spacing(1),
  },
  customError: {
    color: "red",
    fontSize: "0.8rem",
    marginTop: 10,
  },
  submitButton: {
    marginTop: "10px",
  },
  sectionHeader: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
  tableContainers: {
    gap: "2em",
    flexWrap: "wrap-reverse",
  },
  button: {
    "&:focus": {
      color: "white",
      backgroundColor: "#0A94C7",
    },
    "&:hover": {
      color: "white",
      backgroundColor: "#0A94C7",
    },
  },
})

const Alerts = (props) => {
  const { classes, ...rest } = props

  useLazyLoadSelector((state) => state.alerts.alerts, fetchUserAlerts, [], false)
  useLazyLoadSelector((state) => state.alerts.alertSettings, fetchUserAlertSettings, [], true)
  useLazyLoadSelector((state) => state.group.groupData, fetchGroups, [], false)

  return (
    <HomePageWrapper>
      <div>
        <div className={[classes.contentPadding, classes.sectionHeader].join(" ")}>
          <h1>Alerts</h1>
        </div>
        <br />
        <AlertsTable {...rest} className={clsx(classes.root, classes)} tableHeaderColor="info" />
        <br />
      </div>
    </HomePageWrapper>
  )
}

export default withStyles(styles)(Alerts)
